<template>
  <div>
    <h3 v-if="heading" class="stat_section--heading text-uppercase">{{ heading }}</h3>

    <div :class="{'stat_section--grid columns is-multiline my-0': hasColumns}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatsSection",
  props: {
    heading: String,
    hasColumns: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped>
.stat_section--heading {
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 30px;
}

.stat_section--grid {
  align-items: stretch;
}
</style>
